function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Log from '@deephaven/log';
import { ComboBox } from '@deephaven/components';
import { getDefaultConditionConfigForType, getConditionConfig, getDefaultStyleConfig } from "./ConditionalFormattingUtils.js";
import ConditionEditor from "./ConditionEditor.js";
import StyleEditor from "./StyleEditor.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var log = Log.module('RowFormatEditor');
var DEFAULT_CALLBACK = () => undefined;
function makeDefaultConfig(columns) {
  var _columns$ = columns[0],
    type = _columns$.type,
    name = _columns$.name;
  var leftHandValue = {
    type,
    name
  };
  var config = _objectSpread({
    leftHandValue,
    formattedColumns: [],
    style: getDefaultStyleConfig()
  }, getDefaultConditionConfigForType(type));
  return config;
}
function RowFormatEditor(props) {
  var _columns$find;
  var columns = props.columns,
    _props$config = props.config,
    config = _props$config === void 0 ? makeDefaultConfig(columns) : _props$config,
    dh = props.dh,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? DEFAULT_CALLBACK : _props$onChange;
  var _useState = useState((_columns$find = columns.find(c => c.name === config.leftHandValue.name && c.type === config.leftHandValue.type)) !== null && _columns$find !== void 0 ? _columns$find : columns[0]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedColumn = _useState2[0],
    setColumn = _useState2[1];
  var _useState3 = useState(getConditionConfig(config)),
    _useState4 = _slicedToArray(_useState3, 2),
    conditionConfig = _useState4[0],
    setConditionConfig = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    conditionValid = _useState6[0],
    setConditionValid = _useState6[1];
  var _useState7 = useState(config.style),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedStyle = _useState8[0],
    setStyle = _useState8[1];
  var handleColumnChange = useCallback(value => {
    var newColumn = columns.find(_ref => {
      var name = _ref.name;
      return name === value;
    });
    if (newColumn !== undefined) {
      setColumn(newColumn);
      if (selectedColumn.type !== newColumn.type) {
        setConditionConfig(getDefaultConditionConfigForType(newColumn.type));
        setConditionValid(false);
      }
    } else {
      log.error("Column ".concat(value, " not found."));
    }
  }, [columns, selectedColumn]);
  var handleConditionChange = useCallback((updatedConditionConfig, isValid) => {
    log.debug('handleConditionChange', updatedConditionConfig, isValid);
    setConditionConfig(updatedConditionConfig);
    setConditionValid(isValid);
  }, []);
  var handleStyleChange = useCallback(updatedStyleConfig => {
    log.debug('handleStyleChange', updatedStyleConfig);
    setStyle(updatedStyleConfig);
  }, []);
  useEffect(function updateRowFormat() {
    if (selectedColumn === undefined) {
      log.debug('Column is not selected, skip update.');
      return;
    }
    if (selectedStyle === undefined) {
      log.debug('Style is not selected, skip update.');
      return;
    }
    var type = selectedColumn.type,
      name = selectedColumn.name;
    var leftHandValue = {
      type,
      name
    };
    onChange(_objectSpread({
      leftHandValue,
      formattedColumns: [],
      style: selectedStyle
    }, conditionConfig), conditionValid);
  }, [onChange, selectedColumn, selectedStyle, conditionConfig, conditionValid]);
  var columnNames = useMemo(() => columns.map(_ref2 => {
    var name = _ref2.name;
    return name;
  }), [columns]);
  return /*#__PURE__*/_jsxs("div", {
    className: "conditional-rule-editor form",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "mb-2",
      children: [/*#__PURE__*/_jsx("label", {
        className: "mb-0",
        children: "Format Row If"
      }), /*#__PURE__*/_jsx(ComboBox, {
        "aria-label": "Select column to format row by",
        defaultSelectedKey: selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.name,
        onChange: handleColumnChange,
        children: columnNames
      })]
    }), selectedColumn !== undefined && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ConditionEditor, {
        column: selectedColumn,
        columns: columns,
        config: conditionConfig,
        dh: dh,
        onChange: handleConditionChange
      }), /*#__PURE__*/_jsx(StyleEditor, {
        config: selectedStyle,
        onChange: handleStyleChange
      })]
    })]
  });
}
export default RowFormatEditor;
//# sourceMappingURL=RowFormatEditor.js.map